import Swal from 'sweetalert2'

// Shared top-right toast for admin actions (create/update/delete/etc.).
export const toast = (title: string, icon: 'success' | 'error' = 'success') =>
  Swal.fire({
    toast: true,
    position: 'top-end',
    icon,
    title,
    showConfirmButton: false,
    timer: 2600,
    timerProgressBar: true,
  })
